// @flow
import React, { Component } from 'react';
import ProductCardList from 'components/common/ProductCardList/ProductCardList';

class SectionProductCards extends Component<Props> {
  render() {
    const { products } = this.props;
    return products && <ProductCardList products={products} />;
  }
}

export default SectionProductCards;



// WEBPACK FOOTER //
// ./src/containers/list/SectionProductCards.js